// Lazy loader for the target search index. A dynamic import, not a static
// one, so webpack code-splits it into a chunk fetched only when someone
// opens the FOV calculator, not bundled into every page's main JS.
//
// Cached at module scope so the search box and the framing view (which also
// uses it to mark other notable objects nearby) share one fetch.

let searchIndexPromise = null;
export const loadSearchIndex = () => {
    if (!searchIndexPromise) {
        searchIndexPromise = import('../../data/searchIndex.json').then((mod) => mod.default || mod);
    }
    return searchIndexPromise;
};
